import React, { useState } from 'react';
import Sidebar from '../components/sidebar/sidebar';
import SentEmailsTable from '../components/emails/sent-emails-table';
import SentEmailsModal from '../components/emails/sent-emails-modal';

function EmailSentPage() {
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  return (
    <div className="flex items-center justify-center">
      <Sidebar />
        <SentEmailsTable
          setOpenEditModal={setOpenEditModal}
          setSelectedId={setSelectedId}
        />
        {openEditModal && (
          <SentEmailsModal
            open={openEditModal}
            setOpen={setOpenEditModal}
            docId={selectedId}
          />
        )}
      
    </div>
  );
}

export default EmailSentPage; 